import { MobilePanel } from './components/MobilePanelNav/MobilePanelNav'

// Tab order for horizontal swipes on the phone panel — matches the bottom
// nav left-to-right. Swiping left advances (status → turn → finance →
// board), swiping right goes back. The board tab has no panel to swipe on,
// so it can only be LANDED on by a swipe, never left by one (the tab bar
// handles that).
export const PANEL_ORDER: MobilePanel[] = ['status', 'turn', 'finance', 'board']

// Resolve a completed touch gesture into a tab switch, or null when the
// gesture is not a deliberate horizontal swipe:
// - too short (|dx| < minDx), or
// - steeper than it is wide (|dx| < |dy| * axisRatio) — that's a scroll.
export function resolveSwipePanel(
  current: MobilePanel,
  dx: number,
  dy: number,
  minDx = 56,
  axisRatio = 1.5,
): MobilePanel | null {
  if (Math.abs(dx) < minDx || Math.abs(dx) < Math.abs(dy) * axisRatio) {
    return null
  }
  const i = PANEL_ORDER.indexOf(current)
  if (i === -1) {
    return null
  }
  const next = dx < 0 ? i + 1 : i - 1
  if (next < 0 || next >= PANEL_ORDER.length) {
    return null
  }
  return PANEL_ORDER[next]
}
